import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {TimelineDatePipe} from "@app/pipes/timeline-date.pipe";
import {DatePipe} from "@app/pipes/date.pipe";
import {TimePipe} from "@app/pipes/time.pipe";

@Component({
  selector: 'app-cs-ag-grid-custom-cell-renderer',
  templateUrl: './cs-ag-grid-custom-cell-renderer.component.html',
  styleUrls: ['./cs-ag-grid-custom-cell-renderer.component.scss'],
})
export class CsAgGridCustomCellRendererComponent implements OnInit {

    public params: any;
    public cellRenderData: any = [];
    public showFullText: boolean = false;

    constructor(
        private timelineDateTime: TimelineDatePipe,
        private shortDate: DatePipe,
        private timePipe: TimePipe
    ) {
    }
    ngOnInit() {
        if(this.params && this.params.hasOwnProperty('data')){
            this.cellRenderData = this.params.data;
        }
    }

    hasContent(key: any, cellRenderData: any): boolean {
        return !!(
            key.profileImage ||
            (key.type === 'custom_icon' && key.iconsList[cellRenderData[key.iconKey]]) ||
            (key.type === 'static_icon' && key.iconName) ||
            (key.text && cellRenderData[key.text]) ||
            (key.customText && key.customTextList[cellRenderData[key.customTextKey]])
        );
    }

    refresh(params: any): boolean {
        throw new Error("Method not implemented.");
    }

    isDateObject(value: any): value is { date: string } {
        return value && typeof value === 'object' && 'date' in value;
    }

    getUserDate(val: string): string {
        let shortdate = this.shortDate.transform(val);
        let usertime = this.timePipe.transform(val);
        let userDatetime = shortdate + ' (' + usertime + ')';
        return userDatetime;
    }

    getIconClass(iconValue: string | number): string {
        if (typeof iconValue === 'number' || !isNaN(Number(iconValue))) {
            const id = typeof iconValue === 'number' ? iconValue : parseInt(iconValue, 10);
            return this.getIconById(id);
        }
        return iconValue; // return as-is if it's already a string (class name)
    }

    private getIconById(id: number): string {
        const createdByTypes = this.getCreatedbyType();
        const foundType = createdByTypes.find(item => item.id === id.toString());
        return foundType ? foundType.icon : '';
    }

    private getCreatedbyType(): { id: string; text: string; icon: string }[] {
        return [
            {id: '1', text: 'System', icon: 'fa-sharp fa-regular fa-globe'},
            {id: '2', text: 'Online', icon: 'fa-sharp fa-regular fa-globe'},
            {id: '3', text: 'Webservice', icon: 'fa-sharp fa-regular fa-globe'},
            {id: '4', text: 'iPhone', icon: 'fa fa-apple'},
            {id: '5', text: 'iPad', icon: 'fa fa-apple'},
            {id: '6', text: 'Android tablet', icon: 'fa fa-brands fa-android'},
            {id: '8', text: 'Android phone', icon: 'fa fa-brands fa-android'},
        ];
    }

}
